
import React from 'react';

import './style.css';

const Spinner: React.FC = () => {
    return <div className="loading-spinner" />;
};

export default Spinner;
